import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
	getLister,
	updateDismissFiltersUrl,
} from '../../actions/lister-actions';
import TRANSLATIONS from './translations@default.json';

const SidebarClearFiltersButton = () => {
	const { resetAllUrl } = useSelector((state) => state);
	const dispatch = useDispatch();

	if (resetAllUrl === 'null' || !resetAllUrl) {
		return null;
	}

	const clearFiltersFunction = (evt) => {
		evt.preventDefault();
		dispatch(
			getLister(resetAllUrl, {
				type: '',
				trackHistory: true,
			})
		);
		dispatch(updateDismissFiltersUrl(resetAllUrl));
	};

	return (
		<a
			href={resetAllUrl}
			className="text-link text-body-sm"
			onClick={clearFiltersFunction}
			data-tag-name="clear-filters-clicked"
			data-testid="clear-filters-button">
			{TRANSLATIONS.clearButton}
		</a>
	);
};

export default SidebarClearFiltersButton;
